export const TOKEN_STORAGE_KEY = 'user-token'
export const USER_ID_STORAGE_KEY = 'user-id'
export const TOKEN_EXPIRES_AT_KEY = 'token-expires-at'
export const PROFILE_STORAGE_KEY = 'profile'
export const TOKEN_TTL_MS = 7 * 24 * 60 * 60 * 1000

export function readAuthSession (storage = localStorage) {
  return {
    token: storage.getItem(TOKEN_STORAGE_KEY),
    userId: storage.getItem(USER_ID_STORAGE_KEY),
    tokenExpiresAt: storage.getItem(TOKEN_EXPIRES_AT_KEY)
  }
}

export function isCompleteAuthSession (session) {
  return !!(session && session.token && session.userId)
}

export function storeAuthToken (token, storage = localStorage) {
  if (!token) return readAuthSession(storage)

  storage.setItem(TOKEN_STORAGE_KEY, token)
  storage.setItem(TOKEN_EXPIRES_AT_KEY, (Date.now() + TOKEN_TTL_MS).toString())
  return readAuthSession(storage)
}

export function storeAuthSession ({ token, userId }, storage = localStorage) {
  if (!token || !userId) {
    clearAuthSession(storage)
    return null
  }

  storage.setItem(USER_ID_STORAGE_KEY, userId)
  return storeAuthToken(token, storage)
}

export function clearAuthSession (storage = localStorage) {
  storage.removeItem(TOKEN_STORAGE_KEY)
  storage.removeItem(USER_ID_STORAGE_KEY)
  storage.removeItem(TOKEN_EXPIRES_AT_KEY)
  storage.removeItem(PROFILE_STORAGE_KEY)
}

export function reconcileAuthSession (storage = localStorage) {
  const session = readAuthSession(storage)
  if (isCompleteAuthSession(session)) return session

  clearAuthSession(storage)
  return null
}



// WEBPACK FOOTER //
// ./src/utils/authStorage.js